export { DevOs } from '@/utils/types';

// "zhCN"代表中文，"enUK"代表英文，具体请查询国家语言代码表。
// esUS(英语)
export const Lang = {
    zhCN: 'zhCN',
    enUS: 'enUS',
    system: 'system',
};

// 1表示正常模式，2表示深色模式。 3 跟随系统系统
export const ThemeMode = {
    light: 'light',
    dark: 'dark',
    system: 'system',
};
